export default function ServicesSection() {
  const services = [
    {
      category: '個人向け',
      title: 'ボディスキャン健康チェック（人）',
      description: '最新のスキャン技術で、あなたの健康状態を詳しく分析。生活習慣のアドバイスとともに、より良いコンディションづくりをサポートします。',
      image: 'https://public.readdy.ai/ai/img_res/0db05eb2bdfc7612a1a5c0a785cd50b4.jpg',
    },
    {
      category: 'ペット向け',
      title: 'ペットボディスキャン＆ケアアドバイス',
      description: '大切な家族であるペットの健康を、科学的にチェック。食事や運動、日々のケアについて、専門的なアドバイスをお届けします。',
      image: 'https://readdy.ai/api/search-image?query=Veterinary%20professional%20examining%20a%20happy%20dog%20with%20modern%20pet%20health%20scanning%20equipment%20in%20a%20bright%2C%20clean%20animal%20clinic%20with%20white%20and%20light%20blue%20interior%2C%20warm%20and%20caring%20atmosphere%2C%20professional%20pet%20healthcare%20photography%20with%20soft%20natural%20lighting&width=600&height=900&seq=service-pet-scan-001&orientation=portrait',
    },
    {
      category: '法人向け',
      title: '企業向けウェルビーイング研修',
      description: '健康経営の実現に向けた、実践的な研修プログラム。従業員の心身の健康と、組織全体の活力向上を支援します。',
      image: 'https://readdy.ai/api/search-image?query=Corporate%20wellness%20training%20seminar%20with%20diverse%20business%20professionals%20participating%20in%20a%20modern%20bright%20conference%20room%2C%20featuring%20health%20and%20wellbeing%20workshop%20activities%2C%20clean%20white%20and%20light%20blue%20interior%20design%2C%20professional%20business%20photography%20with%20natural%20lighting&width=600&height=900&seq=service-corporate-001&orientation=portrait',
    },
    {
      category: '個人向け',
      title: '個人向けウェルビーイングセッション',
      description: 'こころとからだの状態を丁寧にヒアリング。あなただけのウェルビーイングプランを、一緒に考えます。',
      image: 'https://readdy.ai/api/search-image?query=One-on-one%20wellness%20consultation%20session%20in%20a%20peaceful%2C%20bright%20room%20with%20a%20professional%20counselor%20and%20client%20having%20a%20warm%20conversation%2C%20featuring%20comfortable%20seating%2C%20plants%2C%20natural%20light%2C%20calming%20white%20and%20soft%20blue%20color%20palette%2C%20professional%20lifestyle%20photography&width=600&height=900&seq=service-personal-001&orientation=portrait',
    },
    {
      category: 'イベント',
      title: 'ペット共生コミュニティイベント',
      description: 'ペットと一緒に参加できる交流イベントや学びの場。飼い主同士のつながりも育みます。',
      image: 'https://readdy.ai/api/search-image?query=Community%20event%20with%20people%20and%20their%20pets%20gathering%20in%20a%20bright%20outdoor%20park%20setting%2C%20featuring%20happy%20families%20with%20dogs%20and%20cats%2C%20social%20interaction%2C%20warm%20sunny%20atmosphere%2C%20clean%20and%20vibrant%20photography%20with%20natural%20backgrounds&width=600&height=900&seq=service-community-001&orientation=portrait',
    },
    {
      category: 'オンライン',
      title: 'オンライン講座・動画プログラム',
      description: 'いつでも、どこでも学べるオンラインコンテンツ。ウェルビーイングの知識とスキルを、ご自身のペースで深められます。',
      image: 'https://readdy.ai/api/search-image?query=Person%20learning%20from%20online%20wellness%20course%20on%20laptop%20in%20a%20comfortable%20home%20office%20setup%2C%20featuring%20modern%20technology%2C%20bright%20natural%20lighting%2C%20clean%20minimalist%20workspace%20with%20plants%2C%20professional%20lifestyle%20photography%20with%20white%20and%20light%20blue%20tones&width=600&height=900&seq=service-online-001&orientation=portrait',
    },
  ];

  return (
    <section id="services" className="py-32 bg-white">
      <div className="max-w-[1400px] mx-auto px-10">
        {/* セクションタイトル */}
        <div className="text-center mb-18">
          <p className="text-xs font-semibold tracking-widest bg-gradient-to-r from-[#4A90E2] to-[#50C9C3] bg-clip-text text-transparent mb-4">
            SERVICES &amp; PROGRAMS
          </p>
          <h2 className="text-4xl lg:text-5xl font-bold text-[#1A2B3C] mb-4">
            提供サービス・プログラム
          </h2>
          <p className="text-lg text-[#5A6C7D]">
            あなたに合ったウェルビーイングのかたちを
          </p>
        </div>

        {/* サービスカード */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-7 mt-16">
          {services.map((service, index) => (
            <article
              key={index}
              className="group rounded-[28px] overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 bg-white"
            >
              {/* 画像エリア */}
              <div className="relative aspect-[2/3] w-full h-full overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute top-6 left-6">
                  <span className="px-4 py-1.5 bg-white/90 backdrop-blur-sm text-[#4A90E2] text-xs font-semibold rounded-lg">
                    {service.category}
                  </span>
                </div>
              </div>

              {/* コンテンツエリア */}
              <div className="p-8 bg-white">
                <h3 className="text-xl font-bold text-[#1A2B3C] mb-4 leading-snug">
                  {service.title}
                </h3>
                <p className="text-[15px] leading-relaxed text-[#5A6C7D] mb-6">
                  {service.description}
                </p>
                <button className="text-sm font-semibold bg-gradient-to-r from-[#4A90E2] to-[#50C9C3] bg-clip-text text-transparent flex items-center gap-2 group-hover:gap-3 transition-all duration-300 cursor-pointer whitespace-nowrap">
                  詳しく見る
                  <i className="ri-arrow-right-line"></i>
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
